"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { AspectRatio } from "@/components/ui/aspect-ratio";
export default function Statement() {
  const shouldReduceMotion = useReducedMotion();
  const fadeUpVariants = {
    hidden: {
      opacity: 0,
      y: shouldReduceMotion ? 0 : 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.7,
        ease: [0.22, 1, 0.36, 1]
      }
    }
  };
  const imageVariants = {
    hidden: {
      opacity: 0,
      y: shouldReduceMotion ? 0 : 24
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        delay: shouldReduceMotion ? 0 : 0.2,
        ease: [0.22, 1, 0.36, 1]
      }
    }
  };
  return <section id="herostatement" data-nav="light" className="relative w-full bg-background text-foreground pt-16 md:pt-24 lg:pt-32 pb-16 md:pb-24 selection:bg-muted selection:text-foreground">
      <div className="mx-auto max-w-7xl px-6 md:px-12 lg:px-16">
        {/* Editorial Heading */}
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.3
      }} variants={fadeUpVariants} className="mb-12 md:mb-16 lg:mb-20 max-w-5xl">
          <h1 className="font-serif font-light text-[clamp(2.35rem,4.8vw,4.75rem)] leading-[1.12] tracking-tight text-foreground/95">A space becomes beautiful when it reflects the people who live within it.</h1>
        </motion.div>

        {/* Hero Portrait Photograph */}
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.2
      }} variants={imageVariants} className="w-full overflow-hidden rounded-none shadow-none">
          <AspectRatio ratio={16 / 10} className="w-full bg-muted/40">
            <img data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1781435/img/founders_studio_portrait.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1781435/img/founders_studio_portrait.webp-wvc-sizes" alt="Albion Nord interior design studio founders gathered in a bespoke living space" loading="lazy" decoding="async" className="h-full w-full object-cover grayscale contrast-[1.05] brightness-[0.98] rounded-none transition-[filter] duration-700 hover:grayscale-[0.9]" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1781435/img/exterior-home.jpg" />
          </AspectRatio>
        </motion.div>
      </div>
    </section>;
}